(function() {
  'use strict';

  angular.module('component.organisations', []);
})();
